export var CommentPlusFeature;
(function (CommentPlusFeature) {
    CommentPlusFeature["Ratings"] = "ratings";
    CommentPlusFeature["Stars"] = "stars";
    CommentPlusFeature["Emojis"] = "emojis";
    CommentPlusFeature["Tags"] = "tags";
})(CommentPlusFeature || (CommentPlusFeature = {}));
